// extracted by mini-css-extract-plugin
export default {"checkbox":"WjRbt","declarationContainer":"F0HkE"};